import React from 'react';
import ComponentPicker from '../common/pickers/ComponentPicker';
import styled from 'styled-components';
import { useConfigComponent } from '../hooks/component/useConfigComponent';
const StyledDiv = styled.div ``;
const SiteConfigComponent = ({ component }) => {
    const { changeType } = useConfigComponent(component);
    return (React.createElement(StyledDiv, null,
        React.createElement(ComponentPicker, { label: 'Component', value: (component === null || component === void 0 ? void 0 : component.type) || '', onTypeChange: type => {
                changeType(type);
            } })));
};
export default SiteConfigComponent;
//# sourceMappingURL=SiteConfigComponent.js.map